import styled from "styled-components";

const ComponentMargin = styled.div`
  margin-left: 1rem;
  margin-right: 1rem;

  @media screen and (min-width: 600px) {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  //@media screen and (min-width: 900px) {
  //  margin-left: auto;
  //  margin-right: auto;
  //  width: 836px;
  //}
  //
  //@media screen and (min-width: 1200px) {
  //  margin-left: auto;
  //  margin-right: auto;
  //  width: 1104px;
  //}
`;

export default ComponentMargin;
